import { cache } from '@cornerstonejs/core';
import { isVolumeSegmentation } from './stackVolumeCheck';
function getStrategyData({ operationData, viewport }) {
    let segmentationImageData, segmentationScalarData, imageScalarData;
    if (isVolumeSegmentation(operationData)) {
        const { volumeId, referencedVolumeId } = operationData;
        const segmentationVolume = cache.getVolume(volumeId);
        const imageVolume = cache.getVolume(referencedVolumeId);
        if (!segmentationVolume || !imageVolume) {
            return;
        }
        ({ imageData: segmentationImageData } = segmentationVolume);
        segmentationScalarData = segmentationVolume.getScalarData();
        imageScalarData = imageVolume.getScalarData();
    }
    else {
        const { imageIdReferenceMap, segmentationRepresentationUID } = operationData;
        if (!imageIdReferenceMap) {
            return;
        }
        const currentImageId = viewport.getCurrentImageId();
        if (!currentImageId) {
            return;
        }
        const actor = viewport.getActor(segmentationRepresentationUID);
        segmentationImageData = actor.actor.getMapper().getInputData();
        const currentSegmentationImageId = imageIdReferenceMap.get(currentImageId);
        const segmentationImage = cache.getImage(currentSegmentationImageId);
        segmentationScalarData = segmentationImage.getPixelData();
        const image = cache.getImage(currentImageId);
        imageScalarData = image.getPixelData();
    }
    return {
        segmentationImageData,
        segmentationScalarData,
        imageScalarData,
    };
}
export { getStrategyData };
//# sourceMappingURL=getStrategyData.js.map